import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../common/types';
import { MobileSheet } from '../music24/navigation/mobile/MobileSheet';
import { AddArtistModal } from './AddArtistModal';
import { ArtistSwitcherSheetList } from './ArtistSwitcherSheetList';
import { useArtistSwitcher } from './useArtistSwitcher';
import { artistSwitcherMessages as messages } from './artistSwitcherMessages';

interface ArtistSwitcherSheetProps {
  id: string;
  onClose: () => void;
}

/**
 * design: navigation i1. On mobile web the artist pills of the top bars open the switcher
 * (free-plans d) as a bottom sheet, not as a dropdown: the header with the count, one row per
 * artist, "Add artist" and the at-limit box. A tap on an artist switches and closes the sheet.
 * "Add artist" swaps the sheet for the add-artist window.
 */
const ArtistSwitcherSheetComponent: React.FC<ArtistSwitcherSheetProps> = ({ id, onClose }) => {
  const intl = useIntl();
  const switcher = useArtistSwitcher();
  const { ownAccountCount, artistsLimit, closeAdd } = switcher;

  const closeAddAndSheet = useCallback(() => {
    closeAdd();
    onClose();
  }, [closeAdd, onClose]);

  if (switcher.isAddOpen) {
    return <AddArtistModal isOpen onClose={closeAddAndSheet} />;
  }

  return (
    <MobileSheet
      id={id}
      title={intl.formatMessage(messages.header)}
      aside={
        artistsLimit !== null && ownAccountCount !== undefined
          ? intl.formatMessage(messages.count, { count: ownAccountCount, limit: artistsLimit })
          : undefined
      }
      onClose={onClose}
    >
      <ArtistSwitcherSheetList switcher={switcher} onClose={onClose} />
    </MobileSheet>
  );
};

export const ArtistSwitcherSheet = TypedMemo(ArtistSwitcherSheetComponent);
